import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'
import { isMobile } from 'react-device-detect'
import { Domiciliation } from 'globals/models/Domiciliation'
import Dot from 'components/Dot'
import colors from 'globals/colors'
import { MailIcon, MailFillIcon, ActionsIcon, ActionsFillIcon, FileIcon, FileFillIcon } from 'components/Icons'
import { ClientTabsWrapper, TabsWrapper } from './styles'
import ClientInfos from 'pages/ClientDetails/components/ClientInfos'
import ClientMailsTab from 'pages/ClientDetails/components/ClientMailsTab'
import ClientMailsHistoryTab from 'pages/ClientDetails/components/ClientMailsHistoryTab'
import ClientActionsTab from 'pages/ClientDetails/components/ClientActionsTab'
import { USER_MAILS, UserMailsResult, UserMailsVariables } from 'graphql/mails/queries'
import { displayErrors } from 'globals/graphql'
import { useLazyQuery } from '@apollo/client'

interface IProps {
  domiciliation: Domiciliation
}

const ClientTabs = (props: IProps) => {
  const { t } = useTranslation()
  const { domiciliation } = props
  const defaultPanel = isMobile ? 'info' : 'mails'

  const [fetchMails, { loading, data, refetch }] = useLazyQuery<UserMailsResult, UserMailsVariables>(USER_MAILS, {
    ...displayErrors
  })

  return (
    <ClientTabsWrapper isMobile={isMobile}>
      <TabsWrapper isMobile={isMobile}>
        <Tabs defaultActiveKey={domiciliation.status === 'pending_partner_check' ? 'actions' : defaultPanel}>
          {isMobile && (
            <Tabs.TabPane
              key='info'
              tab={
                <>
                  <FileIcon />
                  <FileFillIcon className='active' />

                  {t('clients.info.tab')}
                </>
              }
            >
              <ClientInfos domiciliation={domiciliation} />
            </Tabs.TabPane>
          )}
          <Tabs.TabPane
            key='mails'
            tab={
              <>
                <MailIcon />
                <MailFillIcon className='active' />

                {t('clients.mails.tab')}
              </>
            }
          >
            <ClientMailsTab
              domiciliation={domiciliation}
              fetchMails={fetchMails}
              loading={loading}
              data={data!}
              refetch={refetch}
            />
          </Tabs.TabPane>

          <Tabs.TabPane
            key='mailsHistory'
            tab={
              <>
                <MailIcon />
                <MailFillIcon className='active' />

                {t('clients.mails.history')}
              </>
            }
          >
            <ClientMailsHistoryTab domiciliation={domiciliation} />
          </Tabs.TabPane>

          <Tabs.TabPane
            key='actions'
            tab={
              <>
                <ActionsIcon />
                <ActionsFillIcon className='active' />

                {t('clients.actions.tab')}

                {domiciliation.status === 'pending_partner_check' && !isMobile && <Dot color={colors.reddishPink} />}
              </>
            }
          >
            <ClientActionsTab domiciliation={domiciliation} fetchMails={fetchMails} />
          </Tabs.TabPane>
        </Tabs>
      </TabsWrapper>
    </ClientTabsWrapper>
  )
}

export default ClientTabs
